const InboxTypes = {
  STANDARD: 'STANDARD',
  SHARED: 'SHARED'
};
export default InboxTypes;